import React, { useCallback } from 'react';
import {
  getMessageActions,
  MessageSimple,
  MessageUIComponentProps,
  useUserRole,
} from 'stream-chat-react';
import { Grid, lighten, makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';

import { CustomSVG } from 'components';
import { useTranslation } from 'react-i18next';

const MESSAGE_ACTIONS = ['edit', 'delete', 'mute', 'pin', 'react', 'reply'];

const useStyles = makeStyles(theme => ({
  pinned: {
    background: lighten(theme.palette.primary.light, 0.1),
    padding: theme.spacing(0, 5),
    margin: theme.spacing(0, -5),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  pin: {
    color: lighten(theme.palette.common.black, 0.5),
    fontSize: 11,
  },
}));

const MessageCustom = (props: MessageUIComponentProps) => {
  const { channel, message, messageActions = Object.keys(MESSAGE_ACTIONS) } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { isAdmin, isModerator, isMyMessage } = useUserRole(message);

  const channelConfig = channel?.getConfig();
  const canEdit = isMyMessage || isModerator || isAdmin;
  const canDelete = canEdit;

  const messageActionsHandler = useCallback(() => {
    if (!message || !messageActions) {
      return [];
    }

    return getMessageActions(messageActions, {
      canDelete,
      canEdit,
      canFlag: !isMyMessage,
      canMute: !isMyMessage && !!channelConfig?.mutes,
      canPin: isAdmin || isModerator,
      canReact: true,
      canReply: true,
    });
  }, [canDelete, canEdit, isMyMessage, message, messageActions]);

  return (
    <Grid className={classNames({ [classes.pinned]: message.pinned })}>
      {message.pinned && (
        <Grid container alignItems="center" direction="row">
          <CustomSVG name="pin" color="primary" size={16} className={classes.icon} />
          <Typography noWrap className={classes.pin}>
            {t('content:pinned')}
          </Typography>
        </Grid>
      )}

      <MessageSimple {...props} getMessageActions={messageActionsHandler} />
    </Grid>
  );
};

export default MessageCustom;
